import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "play-arrow_a9461",
  "use": "play-arrow_a9461-usage",
  "viewBox": "0 0 357 357",
  "content": "<symbol viewBox=\"0 0 357 357\" id=\"play-arrow_a9461\">\n    <path d=\"M38.25 0v357l280.5-178.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol